import clsx from "clsx";
import React from "react";

interface ProductItemProps {
	title: string;
	description?: string | React.ReactNode;
	descriptionBottom?: string;
	list?: string[];
	visual?: {
		url: string;
		title?: string;
	};
	onZoomButtonClick: (visualUrl: string) => void;
}

export function ProductItem({
	title,
	description,
	descriptionBottom,
	list,
	visual,
	onZoomButtonClick,
}: ProductItemProps) {
	const imgTitle = visual.title;
	const imgDescription = imgTitle || `${title} screenshot`;
	const visualUrl = visual.url;
	let content;
	let bullets;

	if (list) {
		bullets = (
			<ul className="ticks ticks--small">
				{list.map((item, index) => (
					<li key={index}>{item}</li>
				))}
			</ul>
		);
	}

	if (description) {
		content =
			typeof description === "string" ? (
				<p>{description}</p>
			) : (
				description
			);
	}

	return (
		<div className="product-item grid">
			<div className="typography grid__col-12 grid__col-md-5 grid__col-xxl-5">
				<p className="title">{title}</p>
				{content}
				{bullets}
				{descriptionBottom && <p>{descriptionBottom}</p>}
			</div>
			<div className="grid__col-md-1 grid__col-xxl-2"></div>
			<div className="grid__col-12 grid__col-md-6 grid__col-xxl-5">
				<div
					className={clsx("visual", {
						"visual--with-title": !!imgTitle,
					})}
				>
					<div className="img-wrapper">
						<img src={visualUrl} alt={imgDescription} />
						<button
							type="button"
							className="btn btn--icon btn--zoom"
							onClick={() => onZoomButtonClick(visualUrl)}
						>
							Zoom {imgDescription}
						</button>
					</div>
					{imgTitle && <p className="img-description">{imgTitle}</p>}
				</div>
			</div>
		</div>
	);
}
